export default {
	body: {
		eid: "root",
		type: "body",
		children: [
			{
				eid: "TU5iJhJ4nI",
				type: "fullwidth",
				children: [
					{
						eid: "rrJ2vE_XsK",
						type: "box",
						children: [
							{
								eid: "zmitKgUA2",
								type: "box",
								children: [
									{
										eid: "5hHiyQ2Atj",
										type: "box",
										children: [
											{
												attrs: {
													title: "",
													text: "<p>Button</p>\n",
													href: "https://chamaileon.io/?x=хамелеон",
												},
												style: {
													lineHeight: "25px",
													color: "white",
													fontSize: "18px",
													fontFamily: "Arial",
													letterSpacing: "normal",
													backgroundColor: "blue",
													backgroundRepeat: "no-repeat",
													backgroundPosition: "center center",
													backgroundImage: "url()",
													backgroundSize: "auto",
													borderRadius: "5px",
													borderLeftColor: "#121212",
													borderLeftStyle: "solid",
													borderLeftWidth: "0px",
													borderBottomColor: "#121212",
													borderBottomStyle: "solid",
													borderBottomWidth: "0px",
													borderRightColor: "#121212",
													borderRightStyle: "solid",
													borderRightWidth: "0px",
													borderTopColor: "#121212",
													borderTopStyle: "solid",
													borderTopWidth: "0px",
													marginLeft: "20px",
													marginBottom: "20px",
													marginRight: "20px",
													marginTop: "20px",
													paddingLeft: "15px",
													paddingBottom: "15px",
													paddingRight: "15px",
													paddingTop: "15px",
													hoverBackgroundColor: "",
													sizeType: "FIT_TO_TEXT",
													fullWidthOnMobile: true,
													align: "center",
												},
												type: "button",
												eid: "_WSDj6Sw6",
												customData: {},
											},
										],
										attrs: {
											hideOnMobile: false,
											hideOnDesktop: false,
										},
										style: {
											backgroundColor: "",
											backgroundPosition: "top center",
											backgroundRepeat: "no-repeat",
											backgroundImage: "url()",
											borderTopColor: "",
											borderTopStyle: "solid",
											borderTopWidth: "0px",
											borderRightColor: "",
											borderRightStyle: "solid",
											borderRightWidth: "0px",
											borderBottomColor: "",
											borderBottomStyle: "solid",
											borderBottomWidth: "0px",
											borderLeftColor: "",
											borderLeftStyle: "solid",
											borderLeftWidth: "0px",
											marginLeft: "0px",
											marginBottom: "0px",
											marginRight: "0px",
											marginTop: "0px",
											paddingLeft: "0px",
											paddingBottom: "0px",
											paddingRight: "0px",
											paddingTop: "0px",
											backgroundSize: "auto",
											borderRadius: "0px",
										},
										customData: {},
									},
								],
								attrs: {
									hideOnMobile: false,
									hideOnDesktop: false,
								},
								style: {
									backgroundColor: "",
									backgroundRepeat: "no-repeat",
									backgroundPosition: "center center",
									backgroundImage: "url()",
									borderRadius: "0px",
									borderLeftColor: "#121212",
									borderLeftStyle: "solid",
									borderLeftWidth: "0px",
									borderBottomColor: "#121212",
									borderBottomStyle: "solid",
									borderBottomWidth: "0px",
									borderRightColor: "#121212",
									borderRightStyle: "solid",
									borderRightWidth: "0px",
									borderTopColor: "#121212",
									borderTopStyle: "solid",
									borderTopWidth: "0px",
									marginLeft: "0px",
									marginBottom: "0px",
									marginRight: "0px",
									marginTop: "0px",
									paddingLeft: "0px",
									paddingBottom: "0px",
									paddingRight: "0px",
									paddingTop: "0px",
									backgroundSize: "auto",
								},
								customData: {},
							},
						],
						attrs: {
							hideOnMobile: false,
							hideOnDesktop: false,
						},
						style: {
							backgroundColor: "",
							backgroundPosition: "center center",
							backgroundRepeat: "no-repeat",
							backgroundImage: "url(https://images.chamaileon.io/5faa7158ec61f57ca4b9be7e/5faa7158ec61f52f03b9be88/1607087407646_1607087405728_mav-header.jpg)",
							borderTopColor: "",
							borderTopStyle: "solid",
							borderTopWidth: "0px",
							borderRightColor: "",
							borderRightStyle: "solid",
							borderRightWidth: "0px",
							borderBottomColor: "",
							borderBottomStyle: "solid",
							borderBottomWidth: "0px",
							borderLeftColor: "",
							borderLeftStyle: "solid",
							borderLeftWidth: "0px",
							marginLeft: "0px",
							marginBottom: "16px",
							marginRight: "16px",
							marginTop: "16px",
							paddingLeft: "0px",
							paddingBottom: "5px",
							paddingRight: "0px",
							paddingTop: "5px",
							backgroundSize: "auto",
							borderRadius: "0px",
						},
						customData: {},
					},
				],
				placeholder: [],
				attrs: {
					hideOnMobile: false,
					lock: false,
					marker: "",
					hideOnDesktop: false,
				},
				style: {
					backgroundColor: "",
					backgroundRepeat: "no-repeat",
					backgroundPosition: "center center",
					backgroundImage: "url()",
					backgroundSize: "auto",
					contentBackgroundColor: "",
					contentBackgroundRepeat: "no-repeat",
					contentBackgroundPosition: "center center",
					contentBackgroundImage: "url()",
					contentBackgroundSize: "auto",
					contentBorderRadius: "0px",
					contentBorderLeftColor: "#121212",
					contentBorderLeftStyle: "solid",
					contentBorderLeftWidth: "0px",
					contentBorderBottomColor: "#121212",
					contentBorderBottomStyle: "solid",
					contentBorderBottomWidth: "0px",
					contentBorderRightColor: "#121212",
					contentBorderRightStyle: "solid",
					contentBorderRightWidth: "0px",
					contentBorderTopColor: "#121212",
					contentBorderTopStyle: "solid",
					contentBorderTopWidth: "0px",
					contentMarginLeft: "0px",
					contentMarginBottom: "0px",
					contentMarginRight: "0px",
					contentMarginTop: "0px",
					contentPaddingLeft: "0px",
					contentPaddingBottom: "0px",
					contentPaddingRight: "0px",
					contentPaddingTop: "0px",
					contentWidth: 600,
					bodyWidth: 600,
				},
				customData: {},
			},
			{
				eid: "lTxl2e4so",
				type: "block-level-loop",
				children: [],
				attrs: {
					lock: false,
					expression: "dummy_expression",
				},
				style: {},
				customData: {},
			},
			{
				eid: "7MLLGm3yG",
				type: "block-level-conditional",
				children: [
					{
						eid: "tbVWioaPaw",
						type: "branch",
						children: [],
						attrs: {
							expression: "dummy_expression",
							type: "if",
						},
						style: {},
						customData: {},
					},
				],
				attrs: {
					lock: false,
				},
				style: {},
				customData: {},
			},
		],
		attrs: {},
		style: {
			backgroundColor: "#FFFFFF",
			backgroundPosition: "center center",
			backgroundRepeat: "repeat",
			backgroundImage: "url()",
			bodyWidth: 600,
			backgroundSize: "auto",
		},
		version: "3.0.0",
		customData: {},
	},
	variables: [],
	title: "Imported Document",
	previewText: "",
	subjectLine: "",
	components: [],
};
